import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import logo from "../../assets/img/logo.png";

const Header = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Container fluid className="sticky-top">
      <Row>
        <Container fluid className="header">
          <Container>
            <Row>
              <Col
                md={12}
                xs={12}
                className="d-flex justify-content-center align-content-center align-items-center flex-column"
              >
                <div onClick={() => scrollToTop()} style={{ cursor: "pointer" }}>
                  <img src={logo} alt="Montironi" />
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </Row>
    </Container>
  );
};

export default Header;
